const noticeTypeToBackendType = {
  1: 'isPush',
  2: 'isEmail',
  3: 'isSms',
  4: 'isPhone',
};
export default noticeTypeToBackendType;
